export class TypeExportModel {
  public id: number = null;
  public codeTypeExport = '';
  public nameTypeExport = '';

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
